
import Component from 'gia/Component';
import Flickity from 'flickity';

export default class OurArtists extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      carousel: {},
      nextButton: {},
      prevButton: {}
    };
  }

  mount() {
    var flkty = new Flickity( this.ref.carousel, {
      // options
      cellAlign: 'center',
      initialIndex: 1,
      contain: false,
      prevNextButtons:false,
      wrapAround:false,
      pageDots: false
    });

    this.ref.prevButton.addEventListener( 'click', function() {
      flkty.previous();
    });
    this.ref.nextButton.addEventListener( 'click', function() {
      flkty.next();
    });

    window.onload = () => {
      flkty.reloadCells()
      flkty.resize()
    }

  }


}